var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLongArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 11,
    viewBox: "0 0 43 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8916 5.94615C42.165 5.67278 42.165 5.22957 41.8916 4.9562L37.4369 0.501428C37.1635 0.228061 36.7203 0.228061 36.4469 0.501427C36.1736 0.774795 36.1736 1.21801 36.4469 1.49138L40.4067 5.45118L36.4469 9.41097C36.1736 9.68434 36.1736 10.1276 36.4469 10.4009C36.7203 10.6743 37.1635 10.6743 37.4369 10.4009L41.8916 5.94615ZM0.935547 6.15117L41.3967 6.15118L41.3967 4.75118L0.935547 4.75117L0.935547 6.15117Z",
    fill: "#37DEFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowIcon);
export default __webpack_public_path__ + "static/media/LongArrowIcon.86320953.svg";
export { ForwardRef as ReactComponent };